@if (solverInfo) {
<div class="widget-container">
  <mat-progress-spinner [color]="workingScoreIssues ? 'warn' : 'accent'" [diameter]="28"
    [mode]="running ? 'indeterminate' : 'determinate'" class="progress-spinner" value="0"></mat-progress-spinner>
  <button (click)="onExplainBestScore()" mat-icon-button type="button" class="explain-button">
    <mat-icon matSuffix>info</mat-icon>
  </button>
</div>
}
